import { render, staticRenderFns } from "./template-transform-two.vue?vue&type=template&id=64cfe09a"
import script from "./template-transform-two.vue?vue&type=script&lang=ts"
export * from "./template-transform-two.vue?vue&type=script&lang=ts"
import style0 from "./template-transform-two.vue?vue&type=style&index=0&id=64cfe09a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports